import { render, staticRenderFns } from "./shareholderStructure.vue?vue&type=template&id=25cb3ea8&scoped=true"
import script from "./shareholderStructure.vue?vue&type=script&lang=js"
export * from "./shareholderStructure.vue?vue&type=script&lang=js"
import style0 from "./shareholderStructure.vue?vue&type=style&index=0&id=25cb3ea8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb3ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cb3ea8')) {
      api.createRecord('25cb3ea8', component.options)
    } else {
      api.reload('25cb3ea8', component.options)
    }
    module.hot.accept("./shareholderStructure.vue?vue&type=template&id=25cb3ea8&scoped=true", function () {
      api.rerender('25cb3ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/shareholderStructure.vue"
export default component.exports